export default "__VITE_ASSET__CpBSIlhC__"